"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendAPIStore = void 0;
const lincd_server_1 = require("../ontologies/lincd-server");
const package_1 = require("../package");
const BackendStore_1 = require("./BackendStore");
const QuadArray_1 = require("lincd/lib/collections/QuadArray");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
/**
 * Passes all request to the BackendAPIStoreProvider which runs on the LINCD Server backend.
 * The backend Storage in turn will likely be configured to connect to other graph stores
 * @see BackendAPIStoreProvider
 */
let BackendAPIStore = class BackendAPIStore extends BackendStore_1.BackendStore {
    constructor(n) {
        if (typeof n === 'string') {
            super();
            this.label = n;
        }
        else {
            super(n);
        }
    }
    loadShape(shapeInstance, request) {
        return Server_1.Server.call(this, 'loadShape', shapeInstance, request).then((quads) => {
            if (quads instanceof QuadArray_1.QuadArray) {
                this.addNewContents(quads);
            }
            else {
                console.log('BackendAPIStore.loadShape: quads is not a QuadArray: ', quads);
            }
            return quads;
        });
    }
    loadShapes(shapeInstances, request) {
        return Server_1.Server.call(this, 'loadShapes', shapeInstances, request).then((quads) => {
            if (quads instanceof QuadArray_1.QuadArray) {
                this.addNewContents(quads);
            }
            else {
                console.log('BackendAPIStore.loadShapes: quads is not a QuadArray: ', quads);
            }
            return quads;
        });
    }
};
exports.BackendAPIStore = BackendAPIStore;
BackendAPIStore.targetClass = lincd_server_1.lincdServer.BackendAPIStore;
exports.BackendAPIStore = BackendAPIStore = __decorate([
    package_1.linkedShape
], BackendAPIStore);
//# sourceMappingURL=BackendAPIStore.js.map